<template lang="pug">
.report-summary
  h1 科目汇总报表

  el-button(@click='toggle_mode()').no-print 年月切換
  el-button(@click='toggle_level()').no-print {{level}} 级科目
  el-button(@click='toggle_state()').no-print {{state === 'all' ? '含未审核' : '已审核'}}

  el-button(@click='toggle_selected_cats("all")' :type='selected_room_category === "all" ? "primary" : ""').no-print 全部楼层
  el-button(v-for='cat in room_categories' :key='cat' :type='selected_room_category === cat ? "primary" : ""' @click='toggle_selected_cats(cat)').no-print {{cat}}

  month-select(:start.sync='date_start', :end.sync='date_end', :mode='mode')

  balance-bar(v-if='selected_room_category === "all"' :date='date_end' :from='date_start' :state='state')

  table.ui.celled.structured.table.olive
    thead
      th.center.aligned 科目
      th.center.aligned.collapsing(style='min-width: 150px') 收入
      th.center.aligned.collapsing(style='min-width: 150px')  支出
      th.center.aligned.collapsing(style='min-width: 150px')  合計
    tbody
      tr(v-for='(row, irow) in data[level].bills', :class='{summary: irow === data[level].length - 1}')
        td {{ get_subject(row._id) }}
        td.right.aligned.positive
          el-popover(placement='right', title='明細', width='200', trigger='hover')
            .detailed(v-html='get_amount_detail(row.incomes)')
            span(slot='reference') {{$formatters.money(get_amount_sum(row.incomes))}}
        td.right.aligned.negative
          el-popover(placement='right', title='明細', width='200', trigger='hover')
            .detailed(v-html='get_amount_detail(row.outcomes)')
            span(slot='reference') {{$formatters.money(get_amount_sum(row.outcomes))}}
        td.right.aligned {{$formatters.money(get_amount_sum(row.incomes) - get_amount_sum(row.outcomes))}}

    tfoot
      tr.summary
        td 合计
        td.right.aligned.positive {{$formatters.money(get_summary(data[level].bills, 'incomes'))}}
        td.right.aligned.negative {{$formatters.money(get_summary(data[level].bills, 'outcomes'))}}
        td.right.aligned {{$formatters.money(get_summary(data[level].bills, 'incomes') - get_summary(data[level].bills, 'outcomes'))}}

</template>

<script>
import MonthSelect from './MonthSelect.vue'
import { BalanceBar } from '../components/basic'

export default {
  name: 'report-subjects',
  components: {
    MonthSelect,
    BalanceBar,
  },
  data() {
    return {
      mode: 'years',
      date_start: this.$moment().subtract(1, 'month'),
      date_end: this.$moment(),
      balance: 0,
      level: 2,
      data: {
        1: {},
        2: {},
        3: {},
      },
      state: 'verified',
      selected_room_category: 'all',
    }
  },
  computed: {
    room_categories() {
      return this.$store.getters.room_categories
    },
  },
  watch: {
    date_end() {
      this.load()
    },
    state() {
      this.load()
    },
    selected_room_category() {
      this.load()
    },
  },
  methods: {
    toggle_mode() {
      if (this.mode === 'years')
        this.mode = 'months'
      else
        this.mode = 'years'
    },
    toggle_level() {
      this.level += 1
      this.level = ((this.level - 1) % 3) + 1
      this.load(this.level)
    },
    toggle_state() {
      if (this.state === 'all')
        this.state = 'verified'
      else
        this.state = 'all'
    },
    load() {
      this.$http
        .get(
          'report/subjects',
          {
            params: {
              level: this.level,
              from: this.date_start.format(),
              to: this.date_end.format(),
              state: this.state === 'all' ? undefined : this.state,
              room_category: this.selected_room_category === 'all' ? undefined : this.selected_room_category,
            },
          }
        )
        .then(data => data.json())
        .then(data => {
          this.data[this.level] = data
        })
        .catch(this.$utils.DefaultErrorHandler.bind(this))
    },
    toggle_selected_cats(cat) {
      if (this.selected_room_category !== cat)
        this.selected_room_category = cat
      else
        this.selected_room_category = 'all'
    },
    get_amount_sum(list) {
      return (list || []).map(i => i.amount || 0).reduce((a, b) => a + b, 0)
    },
    get_payment_method(method) {
      return (
        (this.data[this.level].payment_methods.find(i => i.name === method) || {}).display || '其他'
      )
    },
    get_summary(collection, attr) {
      return (collection || []).map(row => this.get_amount_sum(row[attr])).reduce((a, b) => a + b, 0)
    },
    get_amount_detail(list) {
      return (list || [])
        .filter(i => i.amount)
        .map(
          i =>
            `${this.get_payment_method(i.payment_method)}\t\t${Math.round(
              i.amount || 0
            )}`
        )
        .reduce((a, b) => `${a}<br>${b}`, '')
    },
    get_subject(item) {
      return [item.subject1, item.subject2, item.subject3].filter(i => i).join(' - ')
    },
  },
}
</script>



// WEBPACK FOOTER //
// Subjects.vue?46388b9d